export const AUTH_RESET = 'AUTH_RESET';
export const UI_SET_CART = 'UI_SET_CART';
export const UI_SET_TOKEN = 'UI_SET_TOKEN';
export const UI_SET_ACCOUNT_INFO = 'UI_SET_ACCOUNT_INFO';
export const UI_SET_BASKET = 'UI_SET_BASKET';
export const VERIFY_ACCOUNT = 'VERIFY_ACCOUNT';
export const TOGGLE_ACTIVATION_MODAL = 'TOGGLE_ACTIVATION_MODAL';
